import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useHistory , useLocation } from 'react-router-dom'
import css from '../css/Addcase.module.css'
import { Link } from 'react-router-dom'
import Header from '../Components/Header'
import Rightcontainer from '../Components/Rightcontainer'
import Swal from 'sweetalert2'
import socket from '../Components/socket'
import { useTheme } from '../../ThemeContext'
import { apiRequest } from '../../apiService/allApi'

const Redeem = ({ walletUpdate }) => {
  const history = useHistory ()

   // BASE URL
 
   const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
   const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
   const nodeMode = process.env.NODE_ENV;
   if (nodeMode === "development") {
 
     var baseUrl = beckendLocalApiUrl;
   } else {
     baseUrl = beckendLiveApiUrl;
 }
 // +++++++++++++++++++++++++++++ 

  const [amount, setamount] = useState()
  const [userAllData, setUserAllData] = useState()
  const role = async () => {
    socket.emit('getprofile')

    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    // await axios
    //   .get(baseUrl+`me`, { headers })

      const res = await apiRequest(`me`,"GET",null,headers)
      // .then(res => {
        //console.log(res.data);
        setUserAllData(res.data)
      // })
      // .catch(e => {
      //   if (e.response.status == 401) {
      //     localStorage.removeItem('token')
      //     localStorage.removeItem('token')
      //   }
      // })
  }

  useEffect(() => {
    let access_token = localStorage.getItem('token')
    access_token = localStorage.getItem('token')
    if (!access_token) {
      window.location.reload()
      history.push('/login')
    }
    role()
  }, [])

  const deposit = async () => {
    if (amount && amount >= 95 && amount <= 100000) {
      const access_token = localStorage.getItem('token')
      const headers = {
        Authorization: `Bearer ${access_token}`
      }

     
        const res = await apiRequest(`referral/to/wallet`,"POST", { amount },headers)
       
     
          if (res.data.msg === 'Invalid Amount') {
            Swal.fire({
              title: "You don't have sufficient amount",
              icon: 'warning',
              confirmButtonText: 'OK'
            })
          } else {
            Swal.fire({
              title: 'success',
              icon: 'success',
              confirmButtonText: 'OK'
            })
          }
        // })
        // .catch(e => {
        //   if (e?.response?.status == 401) {
        //     localStorage.removeItem('token')
        //     localStorage.removeItem('token')
        //     window.location.reload()
        //     history.push('/login')
        //   }
        // })
    } else {
      let msg = 'Enter Amount'
      if (!amount) {
        msg = 'Enter Amount'
      } else if (95 <= amount <= 100000) {
        msg = 'Amount should be more than 100.'
      }
      Swal.fire({
        title: msg,
        icon: 'Error',
        confirmButtonText: 'OK'
      })
    }
  }

   // change theme 
    const theme  = localStorage.getItem('theme')
   const styles = {
     backgroundColor: theme === 'light' ? '#fff' : 'black',
     color: theme === 'light' ? 'black' : '#fff',
   };

  return (
    <>
      <Header user={userAllData} />
      <div
        className='leftContainer mb_space bg-gradend-color'
        style={{   minHeight: '100vh', height: '100%' }}
      >
        <div className='Orher_page_main_section'>
           <div className='refer_heading profile_headings '>
              Redeem your refer balance
            </div>
          <img className='w-100' src="/refer_img.png"/>
          <div className='refer_points'>
           <div className='d-flex align-items-center'>
              <div>
                  <img src="/refer-wallet.png"/>
              </div>
            <p className='commaon_para mt-2'>
              TDS (0%) will be deducted after annual referral earning of
              <img
                className='mx-1'
                src={
                  process.env.PUBLIC_URL +
                  '/images/rupee.png'
                }
                alt=''
                width='20x'
                height='20x'
              />{' '}
              15,000.
            </p>
           </div>
           <div className="down-arrow">
            <img src="/down-refer.png"/>
           </div>

            <div className='d-flex align-items-center'>
              <div>
                  <img src="/refer-box.png"/>
              </div>
              <p className='commaon_para mb-0'>
                Money will be added to mannatludo Coin.
              </p>
            </div>
            <div className="down-arrow">
            <img src="/refer-right.png"/>
           </div>
            <div className='d-flex align-items-center'>
              <div>
                  <img src="/refer-wallet.png"/>
              </div>
             <p className='commaon_para mb-0'>
                  Minimum withdrawal amount{' '}
                  <img
                    className='mx-1'
                    src={
                      process.env.PUBLIC_URL +
                      '/images/rupee.png'
                    }
                    alt=''
                    width='20x'
                    height='20x'
                  />{' '}
                  100
                </p>
              </div>


          </div>
          <div className='add_amount_min_max mt-3'>
            <p className='mb-1'> Enter Amount (Min: 100, Max: 10000)</p>
          </div>
          <div>
            <div className='MuiFormControl-root MuiTextField-root  '>
              <input
                class='commaon_input_box'
                type='number'
                style={{ width: '100%' }}
                value={amount}
                placeholder='Enter Amount'
                onChange={e => setamount(parseInt(e.target.value))}
              ></input>
              {/* <div className='add_amount_min_max'>
                <p>
                  Minimum withdrawal amount{' '}
                  <img
                    className='mx-1'
                    src={
                      process.env.PUBLIC_URL +
                      '/images/rupee.png'
                    }
                    alt=''
                    width='20x'
                    height='20x'
                  />{' '}
                  100
                </p>
              </div> */}
              
            </div>
            <div className='add_cash_nest_btn'>
              <button
               
                onClick={() => deposit()}
              >
                Redeem
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default Redeem
